import { Directive } from '@angular/core';

@Directive({
  selector: '[modal-footer]',
})
export class ModalFooterDirective {}
